import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "range-field__cell" }
const _hoisted_2 = {
  key: 0,
  class: "range-field__label label-field"
}
const _hoisted_3 = { class: "range-field__cell" }
const _hoisted_4 = {
  key: 0,
  class: "range-field__label label-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["range-field", { 'range-field--labeled': _ctx.hasLabels }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasLabels)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.labels[0]), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "from", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.hasLabels)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.labels[1]), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "to", {}, undefined, true)
    ])
  ], 2))
}